import { render, staticRenderFns } from "./MoralScore.vue?vue&type=template&id=982b6a68&scoped=true"
import script from "./MoralScore.vue?vue&type=script&lang=js"
export * from "./MoralScore.vue?vue&type=script&lang=js"
import style0 from "./MoralScore.vue?vue&type=style&index=0&id=982b6a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982b6a68",
  null
  
)

export default component.exports